import React from 'react';
import { useFormik } from 'formik';
import './AddNewPartner.scss';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { useTranslation } from 'react-i18next';
import { ISelectorData } from '../application/NewApplication';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { NEW_PARTNER_INFORMATION_INPUTS } from '../../constants/new-partner/new-partner-information';
import {
	convertToPartnerInitialValues, getPartnerDetailsSchema,
	IPartner, PARTNER_FORM_FIELDS, PARTNER_FORM_FIELDS_NAMES,
	partnerInitialValues
} from '../../constants/new-partner/new-partner-form';
import { ButtonComponent } from '../ButtonComponent';
import { setNewPartner } from '../../store/merchnts/actions/partners';
import { IPartnerList } from '../../store/merchnts/merchant-interfaces';
import { useLocation } from 'react-router';

interface IAddNewPartner {
	onSuccess: () => void;
	onError: () => void;
	partner?: IPartnerList;
	setChosenPartner?: (value: IPartnerList | null) => void;
	setPartnerList?: (value: ISelectorData[] | ((prevValue: ISelectorData[]) => ISelectorData[])) => void;
	partnerChange?: (field: string, value: string) => void;
}

export const AddNewPartner = (props: IAddNewPartner): JSX.Element => {
	const { onSuccess, onError, partner, setChosenPartner, setPartnerList, partnerChange } = props;
	const { t } = useTranslation();
	const { search } = useLocation();
	const { merchantState, dispatch } = useMerchants();
	const { isSavingNewPartner, generalError, merchantsLists } = merchantState;
	const formik = useFormik<IPartner>({
		initialValues: partner
			? convertToPartnerInitialValues(partner)
			: partnerInitialValues,
		validationSchema: getPartnerDetailsSchema(t),
		onSubmit: () => setNewPartner(dispatch, formik, partner, setChosenPartner, onSuccess, onError, setPartnerList, partnerChange, search)
	});

	const emailAdditionalClasses = (): string => {
		let classNames = 'col-sm-6 col-md-6';
		if (partner?.id) {
			classNames += ' disabled';
		}
		return classNames;
	};

	const INPUTS = NEW_PARTNER_INFORMATION_INPUTS({ t, partner, emailAdditionalClasses });

	return (
		<form className="row ps-7 pe-8" onSubmit={formik.handleSubmit}>
			<FormInput
				formik={formik}
				key={PARTNER_FORM_FIELDS.PARTNER_NAME}
				fieldName={PARTNER_FORM_FIELDS.PARTNER_NAME}
				label={t(PARTNER_FORM_FIELDS_NAMES.PARTNER_NAME)}
				placeholder={`${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.PARTNER_NAME)}`}
				required
				inputType={InputType.Text}
				additionalClasses="col-sm-6 col-md-6"
			/>
			<FormInput
				formik={formik}
				key={PARTNER_FORM_FIELDS.PARTNER_TYPE}
				fieldName={PARTNER_FORM_FIELDS.PARTNER_TYPE}
				label={t(PARTNER_FORM_FIELDS_NAMES.PARTNER_TYPE)}
				placeholder={t(PARTNER_FORM_FIELDS_NAMES.PARTNER_TYPE)}
				required
				inputType={InputType.Select}
				data={merchantsLists?.partnerTypes}
				searchable={false}
				cleanable={false}
				additionalClasses="col-sm-6 col-md-6"
			/>

			<div className="fs-4 fw-bolder mb-7">Contact Information</div>

			{
				INPUTS.map(item => (
					<FormInput
						{...item}
						formik={formik}
						key={item.key}
					/>
				))
			}

			<div className="col-6 mt-8 text-danger ">
				{generalError}
			</div>
			{/*Button*/}
			<div className="col-6 mb-5 mt-5">
				<ButtonComponent
					additionalClass="d-block ms-auto w-85px"
					buttonName={t('PARTNERS.SAVE_BTN_NAME')}
					loading={isSavingNewPartner}
					isDisabled={isSavingNewPartner}
					type="submit"
				/>
			</div>
		</form>
	);
};
